module.exports = __webpack_public_path__ + "img/logo-lyra-png-transparente.483d5902.png";